import { useTranslation } from "react-i18next";
export const PROVIDER_OPTIONS = () => {
  const { t } = useTranslation();
  return [
  { value: "all", label: t("All") },
  { value: "atmosfera", label: t("Atmosfera") },
  { value: "bGaming", label: t("BGaming") },
  { value: "betGamesTV", label: t("BetGames TV") },
  { value: "betsolutions", label: t("Betsolutions") },
  { value: "enjoyGaming", label: t("Enjoy Gaming") },
  { value: "evolution", label: t("Evolution") },
  { value: "ezugi", label: t("Ezugi") },
  { value: "flexsy", label: t("Flexsy") },
  { value: "habanero", label: t("Habanero") },
  { value: "kaGaming", label: t("Ka Gaming") },
  { value: "nucleusGaming", label: t("Nucleus Gaming") },
  { value: "pragmaticPlay", label: t("Pragmatic Play") },
  { value: "tvbet", label: t("TVBet") },
  { value: "voltent", label: t("Voltent") },
];
};
export const SORT_OPTIONS = () => {
  const { t } = useTranslation();
  return [
  { value: "popular", label: t("Popular"), show: [] },
  { value: "asc", label: t("Asc a-Z"), show: ["/providers"] },
  { value: "desc", label: t("Desc z-A"), show: ["/providers"] },
  { value: "new", label: t("Latest"), show: [] },
];
}
